export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryQSR/theme/components/scorecard/ScorecardView/ScorecardExport.js